import { BodyDefault } from '../../../components/typography';
import { Fragment } from 'react';
import { HStack } from '@terra/ui-styled-system';

interface InfoRowItem {
  label: string;
  value: string | null | undefined;
}

interface InfoRowProps {
  rows: InfoRowItem[];
}

export const InfoRow = ({ rows }: InfoRowProps) => (
  <HStack gap={4} py={2.5} alignItems="flex-start">
    {rows.map(({ label, value }) => {
      const displayValue = value ?? '-';

      return (
        <Fragment key={label}>
          <BodyDefault
            truncate
            color="fg.neutral.muted"
            flexShrink={0}
            w="25%"
            title={label}
          >
            {label}
          </BodyDefault>
          <BodyDefault
            color="fg.neutral.default"
            truncate
            w="25%"
            title={displayValue}
          >
            {displayValue}
          </BodyDefault>
        </Fragment>
      );
    })}
  </HStack>
);
